// @version: 1.0.2
export interface IErrorCodes {
   errorCodePattern?: string;
   errorCodeRequired?: string;
   errorCodeMaxSize?: string;
   errorCodeMinSize?: string;
   errorCodePos?: string;
   errorCodeNeg?: string;
   errorCodeRange?: string;
   errorCodePast?: string;
   errorCodeFuture?: string;
   errorCodeRelative?: string;
   errorCodeDateRange?: string;
   errorCodeDateParse?: string;
   errorCodeValid?: string;
   errorCodeMin?: string;
   errorCodeMax?: string;
   errorCodeDecimal?: string;
}

export enum ERRORPRAFIX {
   PRAEFIX = 'errorCode'
}
